import { ChangeDetectionStrategy, Component, Signal, computed, input } from '@angular/core';

/** Matches <b> / </b> / <b attr…> but not <br> (word boundary after `b`). */
const BOLD_TAG = /<\/?b\b[^>]*>/gi;

@Component({
  selector: 'app-quiz-question-header',
  templateUrl: './quiz-question-header.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class QuizQuestionHeaderComponent {
  readonly heading = input.required<string>();
  readonly subText = input<string>('');

  // The quiz header is already bold, so drop the backend copy's <b> tags (keep <br> and the rest).
  readonly headingHtml: Signal<string> = computed(() => this.heading().replace(BOLD_TAG, ''));
  readonly subTextHtml: Signal<string> = computed(() => this.subText().replace(BOLD_TAG, ''));
}
